import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { JobBoard } from '@shared/models/job-board';
import { Pagination } from '@shared/pagination';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class JobBoardService extends ApiService<any> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'job-board/';
  }

  getAllJobBoards(offset: any): Observable<Pagination<JobBoard>> {
    return this.get({ params: { offset, size: 25 } });
  }

  updateJobBoard(body: Partial<JobBoard>, id: number): Observable<JobBoard> {
    return this.patch<JobBoard>({ body, id });
  }

  getAllJobBoardsWithoutPagination(): Observable<JobBoard[]> {
    return this.get({ url: 'list' });
  }

  getJobBoardByCanonicalName(canonicalName: string): Observable<JobBoard> {
    return this.get({ url: 'canonical/', id: canonicalName });
  }
}
